export default {
  baseRadioButton: {
    padding: 7,
    height: '1.7rem'
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/radio-buttons.js